<template>
    <div class="page">
        <Header 
          ref="header"
          @showTask="taskDialogVisible=true" 
          @loadPy="handleLoadPy" 
          @showVideo="vedioVisibile = true" 
          @setBookSubInfo="handleSetBookSubInfo" 
          @setTaskList="handleSetTaskList"
          @showMind="mindVisibile=true"
          @saveToLocal="handleSaveToLocal"
          @getData="handleGetData"
          @saveProjec="(title)=>{this.form.name=title,projectVisibility = true}"
          @updateForm="(info)=>form = {...form,...info}"
        />
        
        <div class="work-space">
            <ToolBar/>
            <PyEdit ref="edit"/>
            <PyShow/>
        </div>
        <Dialog  title="任务清单" :taskList="taskList" :bookSubInfo="bookSubInfo" :type=1 v-if="taskDialogVisible"   @close="taskDialogVisible=false" v-drag></Dialog>
        <Dialog  title="教学视频"  :bookSubInfo="bookSubInfo" :type=2 v-if="vedioVisibile"   @close="vedioVisibile=false" v-drag></Dialog>
        <Mind  v-if="mindVisibile" @close="mindVisibile=false" />
          <el-dialog
            title="保存作品"
            :visible.sync="projectVisibility"
            width="30%"
            :before-close="()=> projectVisibility= false">
          <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="作品名称" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="作品简介" prop="content">
              <el-input type="textarea" v-model="form.content"></el-input>
            </el-form-item>
            <el-form-item label="操作说明" prop="information">
             <el-input type="textarea" v-model="form.information"></el-input>
            </el-form-item>
          </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="projectVisibility = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
  import Header from '../components/Header'
  import ToolBar from '../components/ToolBar'
  import PyEdit from '../components/PyEdit'
  import PyShow from '../components/PyShow'
  import drag from '@/directives/drag/index.js'
  import {info} from '@/api/book-task.js'
  import Dialog from '../components/Dialog'
  import Mind from '@/pages/Mind'
  export default {
    name: 'Work',
    directives: {
      drag: drag
    },
    components: {
      ToolBar,
      Header,
      PyEdit,
      PyShow,
      Dialog,
      Mind
    },
    data () {
      return {
        info: [],
        authId: '',
        taskDialogVisible: false, // 是否显示任务提示
        vedioVisibile: false, // 是否显示教学视频
        mindVisibile: false, // 是否显示思维导图
        bookSubInfo:{},// 小节内容
        taskList: [], // 任务列表
        projectVisibility: false,
        form: {
          name: '',
          content: '',
          information: ''
        },
        rules: {
          name: [
            { required: true, message: '请输入作品名称', trigger: 'blur' },
          ]
        }
      }
    },
  
    created () {
    },
    methods:{
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.handleSaveProject()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleSaveProject(){
         this.$refs.header.handleSaveProject(this.form)
         this.projectVisibility = false
      },
      handleGetData(fn){
        fn(this.$refs.edit.getData())
      },
      handleSaveToLocal(title){
        this.$refs.edit.saveToLocal(title)
      },
      handleLoadPy(text){
         this.$refs.edit.loadPy(text)
      },
      handleSetBookSubInfo(info){
        this.bookSubInfo = info
      },
      handleSetTaskList(items){
        this.taskList = items
      }
    }
  }
</script>

<style scoped>
    .page, .work-space {
        height: 100%;
        width: 100%;
    }

    .work-space {
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        -webkit-flex-direction: row;
        flex-wrap: nowrap;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Work.vue